import template from './secureFileUploader.html';
import controller from './secureFileUploader.controller';

let secureFileUploaderComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default secureFileUploaderComponent;



// WEBPACK FOOTER //
// ./app/components/secureFileUploader/secureFileUploader.component.js